import * as React from 'react'
import controlStore from '../../../store/controlStore.ts'

interface Props {
	children: React.ReactNode
	open: boolean
	menu: React.ReactNode
}

export const FindDrawer: React.FC<Props> = (props) => {
	const {children, open, menu} = props
	
	const isMobile = controlStore(s => s.isOnMobileDevice)
	const style = !isMobile ? {marginTop: '10vh'} : {}
	const drawer = (
		<div className="drawer drawer-end" data-theme={'gibi'}>
			<input id="find-drawer" type="checkbox" className="drawer-toggle" checked={open} onChange={() => undefined}/>
			<div className="drawer-content">
				{children}
			</div>
			<div className="drawer-side z-20 h-[90vh]" style={style}>
				<div className={'flex justify-center items-center h-full w-full backdrop-blur-sm'}>
					{/*<label htmlFor="find-drawer" aria-label="close sidebar" className="drawer-overlay"></label>*/}
					{menu}
				</div>
			</div>
		</div>
	)

    return drawer
}
